import React from 'react';
import Popup from '../components/Popup';

const Service = () => {
  return (
    <React.Fragment>

      {/* <div className="about_top">
  <div className="container">
    <div className="about">
      <div className="service_grid">
        <div className="col-md-3  col-sm-12 service_box">
          <a className="fancybox" href="images/s1.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s1.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House1</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s2.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s2.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House2</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3  col-sm-12 service_box">
          <a className="fancybox" href="images/s3.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s3.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House3</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3  col-sm-12 service_box">
          <a className="fancybox" href="images/s4.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s4.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House4</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="clearfix"> </div>
      </div> 
      <div className="service_grid">
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s5.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s5.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House5</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s6.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s6.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House6</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s7.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s7.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House7</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s8.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s8.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House8</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="clearfix"> </div>
      </div> 
      <div className="service_grid1">
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s9.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s9.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House9</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s10.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s10.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House10</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s11.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s11.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House11</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="col-md-3 col-sm-12 service_box">
          <a className="fancybox" href="images/s12.jpg" data-fancybox-group="gallery" title="Product Name"><img src="images/s12.jpg" className="img-responsive" alt /><span> </span></a>
          <h3>House12</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua<span>  <a href="#">[...]</a></span></p>
        </div>
        <div className="clearfix"> </div>
      </div> 
    </div>
  </div>
  </div> */}
  
      <div className='container'>
        <div className='row'>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"none"}}>
              <img src="images/s1.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Loan Pre-Approval</h5>
                <p className="card-text">The most significant step in the purchasing of a home is this. There’s no point in going forward without,</p>
                <button type="button" class="btn btn-warning">Read More</button>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem',border:"none" }}>
              <img src="images/s2.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Research</h5>
                <p className="card-text">Buying a home where you and your family can live peacefully and comfortably is the ideal goal. To achieve this goal,</p>
                <button type="button" class="btn btn-warning">Read More</button>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem',border:"none" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Making an Offer</h5>
                <p className="card-text">We will help you to understand the price and make an offer to the seller once you have found your dream home. If required,</p>
                <button type="button" class="btn btn-warning">Read More</button>
              </div>
            </div>
          </div>
        </div>
      </div>



     <div className='container'>
      <h2 className="service-head">OUR PROJECTS</h2>
      <div className='row gy-3' >
      <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014"}}>
              <img src="images/s1.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance Jade Garden Phase II</h5>
                <p className="card-text">Sholinganallur, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">underconstruction</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                {/* <Popup /> */}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s2.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance Blossom</h5>
                <p className="card-text">Pallavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">Ready to Occupy</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">underconstruction</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">Ready to Occupy</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">Ready to Occupy</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">underconstruction</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">underconstruction</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">Ready to Occupy</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4  col-sm-12'>
            <div className="card" style={{ width: '23rem', border:"3px solid #00000014" }}>
              <img src="images/s3.jpg" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Radiance The Pride</h5>
                <p className="card-text">Madhavaram, Chennai</p>
                <p className="card-text">BHK: 2 & 3</p>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <button type="button" class="btn btn-danger">Ready to Occupy</button>
                <button type="button" class="btn btn-warning">viewMore</button>
                </div>
              </div>
            </div>
          </div>
      
        
    
     
      
      </div>
     </div>

    </React.Fragment>
  );
}

export default Service;
